import _ from 'lodash';
import { createSelector } from 'reselect';
import { repositoriesByIdSelector } from './repositories';

export const getServicesSelector = state => _.get(state, 'services', []);

export const servicesWithExistedReposOnlySelector = createSelector(
  [repositoriesByIdSelector, getServicesSelector],
  (repositoriesById, services) => {
    const servicesWithExistedReposOnly = services.reduce((acc, service) => {
      const pathStrategy = service?.settings?.path_strategy || [];
      const pathStrategyWithExistedReposOnly = pathStrategy.filter(
        strategy => !!repositoriesById[strategy?.repository_id]
      );

      const serviceWithExistedReposOnly = {
        ...service,
        settings: {
          ...(service?.settings || {}),
          path_strategy: pathStrategyWithExistedReposOnly
        }
      };

      return [...acc, serviceWithExistedReposOnly];
    }, []);

    return servicesWithExistedReposOnly;
  }
);
